import React from 'react';
import { useSelector } from 'react-redux';
import EquipmentTemplate from '../../components/equiqtemplate/EquipmentTemplate';
import OperatorImg1 from '../../assest/Operter-1.png';
import OperatorImg2 from '../../assest/Operator-2.png';
import OperatorImg3 from '../../assest/Operator-3.png';

// Operator list with translations
const operatorList = (language) => [
  {
    name: {
      gb: "Certified Crane Operator",
      sa: "مشغل رافعة معتمد",
      fr: "Opérateur de grue certifié",
      de: "Zertifizierter Kranführer"
    },
    image: OperatorImg1,
    specs: {
      gb: "Experienced in heavy lifting and crane operation.",
      sa: "خبرة في الرفع الثقيل وتشغيل الرافعات.",
      fr: "Expérimenté dans le levage lourd et l'opération de grues.",
      de: "Erfahren im schweren Heben und Kranbetrieb."
    },
    description: {
      gb: "Qualified operators ensuring safety and efficiency on site.",
      sa: "مشغلون مؤهلون يضمنون السلامة والكفاءة في الموقع.",
      fr: "Opérateurs qualifiés assurant sécurité et efficacité sur site.",
      de: "Qualifizierte Bediener, die Sicherheit und Effizienz auf der Baustelle gewährleisten."
    },
  },
  {
    name: {
      gb: "Forklift Operator",
      sa: "مشغل رافعة شوكية",
      fr: "Opérateur de chariot élévateur",
      de: "Gabelstaplerfahrer"
    },
    image: OperatorImg2,
    specs: {
      gb: "Trained in warehouse and loading operations.",
      sa: "مدرب على عمليات المستودعات والتحميل.",
      fr: "Formé aux opérations d'entrepôt et de chargement.",
      de: "Ausgebildet in Lager- und Ladeoperationen."
    },
    description: {
      gb: "Skilled in handling forklifts with precision and care.",
      sa: "ماهر في التعامل مع الرافعات الشوكية بدقة وعناية.",
      fr: "Compétent dans la manipulation des chariots élévateurs avec précision et soin.",
      de: "Geschickt im Umgang mit Gabelstaplern mit Präzision und Sorgfalt."
    },
  },
  {
    name: {
      gb: "Excavator Operator",
      sa: "مشغل حفارة",
      fr: "Opérateur de pelleteuse",
      de: "Baggerführer"
    },
    image: OperatorImg3,
    specs: {
      gb: "Expert in excavator machinery for various terrains.",
      sa: "خبير في تشغيل الحفارات لمختلف التضاريس.",
      fr: "Expert en machinerie d'excavatrice pour divers terrains.",
      de: "Experte für Baggermaschinen auf verschiedenen Geländearten."
    },
    description: {
      gb: "Efficient operation of excavators for construction projects.",
      sa: "تشغيل فعال للحفارات لمشاريع البناء.",
      fr: "Exploitation efficace des excavatrices pour les projets de construction.",
      de: "Effizienter Betrieb von Baggern für Bauprojekte."
    },
  },
];

// Translations for Operator page
const translations = {
  gb: {
    heading: "Operator Services",
    introText: "Professional operators trained to handle various machinery safely and efficiently.",
    categoriesTitle: "Our Operator Types",
    featuredTitle: "Featured Operators",
    featuredDescription: "Highly skilled operators for your project needs.",
  },
  sa: {
    heading: "خدمات المشغلين",
    introText: "مشغلون محترفون مدربون على تشغيل مختلف الآلات بأمان وكفاءة.",
    categoriesTitle: "أنواع المشغلين لدينا",
    featuredTitle: "المشغلون المميزون",
    featuredDescription: "مشغلون ماهرون لتلبية احتياجات مشروعك.",
  },
  fr: {
    heading: "Services d'opérateurs",
    introText: "Opérateurs professionnels formés pour manipuler diverses machines en toute sécurité et efficacité.",
    categoriesTitle: "Nos types d'opérateurs",
    featuredTitle: "Opérateurs en vedette",
    featuredDescription: "Opérateurs hautement qualifiés pour vos besoins de projet.",
  },
  de: {
    heading: "Bedienerservices",
    introText: "Professionelle Bediener, die geschult sind, verschiedene Maschinen sicher und effizient zu bedienen.",
    categoriesTitle: "Unsere Bedienertypen",
    featuredTitle: "Vorgestellte Bediener",
    featuredDescription: "Hochqualifizierte Bediener für Ihre Projektanforderungen.",
  },
};

const Operator = () => {
  const { language } = useSelector((state) => state.language);
  const t = translations[language] || translations.gb;
  
  // Process operator list with current language
  const processedOperatorList = operatorList().map(item => ({
    name: item.name[language] || item.name.gb,
    image: item.image,
    specs: item.specs[language] || item.specs.gb,
    description: item.description[language] || item.description.gb
  }));

  return (
    <EquipmentTemplate
      content={t}
      equipmentList={processedOperatorList}
      language={language}
    />
  );
};

export default Operator;